import { Constant, Headers } from "../apiConstants";

const GetDineInOutletDetailAPI = async ({outletId, outletNo}) => {
  // const endpoint = Constant.GET_DINEIN_OUTLET_DETAIL + `?outletId=${outletId}`;
  let endpoint = Constant.GET_DINEIN_OUTLET_DETAIL;

  if (outletId) {
    endpoint += `?outletId=${outletId}`;
  } else if (outletNo) {
    endpoint += `?outletNo=${outletNo}`;
  } else {
    throw new Error("Neither outletId nor outletNo is provided.");
  }

  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "get",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default GetDineInOutletDetailAPI;
